import { useParams } from 'react-router-dom'

function useEventIdFromParams() {
	const params = useParams()
	const eventId = params.eventId
	return eventId
}

export default useEventIdFromParams
